import { render } from "./TruthrSupport.vue?vue&type=template&id=22510286&scoped=true"
import script from "./TruthrSupport.vue?vue&type=script&lang=js"
export * from "./TruthrSupport.vue?vue&type=script&lang=js"

import "./TruthrSupport.vue?vue&type=style&index=0&id=22510286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22510286"]])

export default __exports__